__turbopack_context__.v({
  "aiCard": "ParagraphTechStack-module__Q28jNW__aiCard",
  "aiGrid": "ParagraphTechStack-module__Q28jNW__aiGrid",
  "aiIcon": "ParagraphTechStack-module__Q28jNW__aiIcon",
  "aiName": "ParagraphTechStack-module__Q28jNW__aiName",
  "aiSubheading": "ParagraphTechStack-module__Q28jNW__aiSubheading",
  "eyebrow": "ParagraphTechStack-module__Q28jNW__eyebrow",
  "lead": "ParagraphTechStack-module__Q28jNW__lead",
  "section": "ParagraphTechStack-module__Q28jNW__section",
  "techGrid": "ParagraphTechStack-module__Q28jNW__techGrid",
  "techIcon": "ParagraphTechStack-module__Q28jNW__techIcon",
  "techName": "ParagraphTechStack-module__Q28jNW__techName",
  "techTile": "ParagraphTechStack-module__Q28jNW__techTile",
  "title": "ParagraphTechStack-module__Q28jNW__title",
});
